module.exports = __webpack_public_path__ + "static/media/whiteLogo.94819a0c.png";